import API_BASE_URL from "../../../../../Constants";

// Fetch all contacts that can be assigned to a management company
export const fetchAllContacts = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts/get-all`, {
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to fetch contacts");
  const allContacts = await response.json();

  return allContacts;
};

// Fetch assigned contacts for a specific management company
export const fetchAssignedContacts = async (customerId) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/customer-contact-intersections/customer/${customerId}`,
    {
      credentials: "include",
    }
  );
  if (!response.ok) throw new Error("Failed to fetch assigned contacts");
  return response.json();
};

// Update the list of assigned contacts for a management company
export const updateAssignedContacts = async (customerId, contacts) => {
  const contactsDto = contacts.map((contact) => ({
    contactId: contact.contactID,
    customerId: customerId,
    mainContact: contact.mainContact || false,
    agentContact: contact.agentContact || false,
    collectionsContact: contact.collectionsContact || false,
  }));

  const response = await fetch(
    `${API_BASE_URL}/api/setup/customer-contact-intersections/update/${customerId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(contactsDto),
    }
  );
  if (!response.ok) throw new Error("Failed to update assigned contacts");
};

export const addNewContact = async (contactData) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(contactData),
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to add contact");
  }

  return response.json();
};

export const updateContact = async (contactId, contactData) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/contacts/${contactId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(contactData),
      credentials: "include",
    }
  );
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to update contact");
  }
  return response.json();
};
